<template>
  <div>
    <b-card-title class="mb-2">
      {{ $t('settings.coordinates.utm.title') }}
    </b-card-title>
    <b-card-text class="mb-3 text-muted">
      {{ $t('settings.coordinates.utm.description') }}
    </b-card-text>

    <b-form @submit.prevent="handleSubmit">
      <b-row>
        <!-- Zone -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            :label="$t('settings.coordinates.utm.zone')"
            label-for="utm-zone"
            :description="$t('settings.coordinates.utm.zone_desc')"
          >
            <b-form-input
              id="utm-zone"
              v-model.number="form.zone"
              type="number"
              min="1"
              max="60"
              step="1"
              required
            />
          </b-form-group>
        </b-col>

        <!-- Hemisphere -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            :label="$t('settings.coordinates.utm.hemisphere')"
            label-for="utm-hemisphere"
            :description="$t('settings.coordinates.utm.hemisphere_desc')"
          >
            <b-form-select
              id="utm-hemisphere"
              v-model="form.hemisphere"
              :options="hemisphereOptions"
              required
            />
          </b-form-group>
        </b-col>

        <!-- False Easting -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            :label="$t('settings.coordinates.utm.false_easting')"
            label-for="utm-false-easting"
            :description="$t('settings.coordinates.utm.false_easting_desc')"
          >
            <b-form-input
              id="utm-false-easting"
              v-model.number="form.false_easting"
              type="number"
              step="0.01"
              required
            />
          </b-form-group>
        </b-col>

        <!-- False Northing -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            :label="$t('settings.coordinates.utm.false_northing')"
            label-for="utm-false-northing"
            :description="$t('settings.coordinates.utm.false_northing_desc')"
          >
            <b-form-input
              id="utm-false-northing"
              v-model.number="form.false_northing"
              type="number"
              step="0.01"
              required
            />
          </b-form-group>
        </b-col>

        <!-- Scale Factor -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            :label="$t('settings.coordinates.utm.scale_factor')"
            label-for="utm-scale-factor"
            :description="$t('settings.coordinates.utm.scale_factor_desc')"
          >
            <b-form-input
              id="utm-scale-factor"
              v-model.number="form.scale_factor"
              type="number"
              step="0.000001"
              required
            />
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Actions -->
      <div class="d-flex justify-content-end mt-2">
        <b-button
          variant="outline-secondary"
          class="mr-1"
          :disabled="loading"
          @click="resetForm"
        >
          {{ $t('common.reset') }}
        </b-button>
        <b-button
          variant="primary"
          type="submit"
          :disabled="loading"
        >
          <b-spinner
            v-if="loading"
            small
            class="mr-50"
          />
          {{ $t('common.save') }}
        </b-button>
      </div>
    </b-form>
  </div>
</template>

<script>
import {
  BCardTitle,
  BCardText,
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BRow,
  BCol,
  BButton,
  BSpinner,
} from 'bootstrap-vue'

export default {
  name: 'UtmSettingsForm',
  components: {
    BCardTitle,
    BCardText,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BRow,
    BCol,
    BButton,
    BSpinner,
  },
  props: {
    settings: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        zone: 36,
        hemisphere: 'N',
        false_easting: 500000,
        false_northing: 0,
        scale_factor: 0.9996,
      },
      hemisphereOptions: [
        { value: 'N', text: this.$t('settings.coordinates.utm.north') },
        { value: 'S', text: this.$t('settings.coordinates.utm.south') },
      ],
    }
  },
  watch: {
    settings: {
      immediate: true,
      deep: true,
      handler(newSettings) {
        if (newSettings && Object.keys(newSettings).length > 0) {
          this.form = { ...this.form, ...newSettings }
        }
      },
    },
  },
  methods: {
    handleSubmit() {
      this.$emit('save', { ...this.form })
    },
    resetForm() {
      if (this.settings && Object.keys(this.settings).length > 0) {
        this.form = { ...this.settings }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.mr-50 {
  margin-right: 0.5rem;
}
</style>
